import React from "react";
import {Card, Col, Row} from "react-bootstrap";
import CustomerNumberCell from "./CustomerNumberCell.jsx";
import HeaderWithHelp from "./HeaderWithHelp.jsx";
import {shortPriceGroup} from "./format.js";

function Field({label, help, children}) {
    return (
        <div className="mb-2">
            <div className="small text-muted">
                <HeaderWithHelp help={help}>{label}</HeaderWithHelp>
            </div>
            <div>{children ?? "–"}</div>
        </div>
    );
}

/** Kopf der Kundenseite: Stammdaten und Zuständigkeit auf einen Blick. */
export default function CustomerHeadCard({customer}) {
    if (!customer) {
        return null;
    }
    const kurzePreisgruppe = shortPriceGroup(customer.price_group);
    return (
        <Card className="shadow-sm mb-3">
            <Card.Body>
                <Row>
                    <Col md={3}>
                        <Field
                            label="Kundennummer"
                            help="weclapp-Kundennummer; kleinere Zahl darunter ist die frühere Majesty-Nummer, falls vorhanden."
                        >
                            <CustomerNumberCell customerNumber={customer.customer_number} legacyNumbers={customer.legacy_numbers} />
                        </Field>
                    </Col>
                    <Col md={3}>
                        <Field label="Name" help="Kundenname aus weclapp.">{customer.name}</Field>
                    </Col>
                    <Col md={2}>
                        <Field
                            label="Branche"
                            help="Aus dem weclapp-Kundenstamm, aktueller Stand, gilt rückwirkend für alle Jahre. Standard wie in der Excel-Auswertung: Graffiti und Fine Arts."
                        >
                            {customer.sector}
                        </Field>
                    </Col>
                    <Col md={1}>
                        <Field label="PG" help="Preisgruppe des Kunden in weclapp.">
                            {kurzePreisgruppe || "–"}
                            {kurzePreisgruppe && kurzePreisgruppe !== customer.price_group && (
                                <span className="small text-muted ms-1">{customer.price_group}</span>
                            )}
                        </Field>
                    </Col>
                    <Col md={1}>
                        <Field label="Land" help="Land laut weclapp-Kundenstamm.">{customer.country}</Field>
                    </Col>
                    <Col md={2}>
                        <Field label="Kontinent" help="Kontinent, aus dem Land abgeleitet (country_regions).">{customer.continent}</Field>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <Field
                            label="Zuständiger"
                            help="Kundenverantwortlicher in weclapp, über den Benutzer dem Kürzel zugeordnet (Stammdaten)."
                        >
                            {customer.responsible?.name || "Nicht zugeordnet – prüfen"}
                        </Field>
                    </Col>
                    {!customer.responsible?.name && (
                        <Col md={3}>
                            <Field
                                label="Frühere Zuordnung"
                                help="Letzte bekannte Zuordnung aus der Vorlage, falls in weclapp kein Zuständiger eingetragen ist."
                            >
                                {customer.previous_rep}
                            </Field>
                        </Col>
                    )}
                </Row>
            </Card.Body>
        </Card>
    );
}
